(() => {
  const SECTION_SELECTOR = '.oddit-section-faq';

  function initSection(section) {
    const triggers = section.querySelectorAll('[data-faq-trigger]');

    for (const trigger of triggers) {
      trigger.addEventListener('click', handleToggle);
    }
  }

  function handleToggle(e) {
    const trigger = e.currentTarget;
    const item = trigger.closest('[data-faq-item]');
    const answer = item.querySelector('[data-faq-answer]');
    if (!answer) return;
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    trigger.setAttribute('aria-expanded', String(!isExpanded));
    answer.setAttribute('aria-hidden', String(isExpanded));

    if (isExpanded) {
      answer.hidden = true;
    } else {
      answer.hidden = false;
    }
  }

  function destroySection(section) {
    const triggers = section.querySelectorAll('[data-faq-trigger]');
    for (const trigger of triggers) {
      trigger.removeEventListener('click', handleToggle);
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();